import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-empty-flag",
  "use": "icon-empty-flag-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-empty-flag\"><path d=\"M21.571 6.17h-6.857V3.143a.856.856 0 00-.857-.857H2.93V1.214A.215.215 0 002.714 1h-1.5A.215.215 0 001 1.214v21c0 .118.096.215.214.215h1.5a.215.215 0 00.215-.215v-7.071H9.57v3.027c0 .474.383.857.858.857H21.57a.856.856 0 00.858-.857V7.027a.856.856 0 00-.858-.857zM2.93 13.214v-9h9.857v9H2.929zM20.5 17.098h-9v-1.955h3a.215.215 0 00.214-.214v-6.83H20.5v9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol